/**
 * skExtra directive, used for working with extras on the FBS mobile screens
 */
bookingApp.directive('skExtra', function(){
    return {
        scope: {
            extraName: '=',
            thumbnails: '=?',
            initialThumbnailIndex: '=?',
            price: '=',
            pricingType: '=',
            unformattedPrice: '=',
            showUnavailable: '='
        },
        template: '<div class="extra" ng-if="unformattedPrice <= 0 && unformattedPrice === null && showUnavailable || unformattedPrice !== null">' +
            '<div class="extra-thumbnail" style="background-image: url({{thumbnails[initialThumbnailIndex]}});"></div>' +
            '<div class="extra-info row">' +
                '<div class="extra-blurb col-xs-8">' +
                    '<div class="marketing-name">' +
                        '<h2><strong>{{extraName}}</strong></h2>' +
                    '</div>' +
                '</div>' +
                '<div class="extra-pricing col-xs-4">' +
                    '<div class="price text-right formatted-price" ng-show="unformattedPrice > 0">' +
                        'From: <br/>' +
                        '<strong>{{price}}</strong><br />' +
                        '{{pricingType | lowercase}}' +
                    '</div>' +
                    '<div class="price text-right price-free" ng-show="unformattedPrice <= 0 && unformattedPrice !== null"><strong>Free</strong></div>' +
                    '<div class="price text-right unavailable" ng-show="unformattedPrice <= 0 && unformattedPrice === null"><strong>Unavailable</strong></div>' +
                '</div>' +
            '</div>' +
        '</div>',
        link: function(scope, element, attrs){
            if(scope.thumbnails && scope.thumbnails.length >= scope.initialThumbnailIndex) {
                element.css('background-color', 'yellow');
                element.find('.extra-thumbnail').css('background-color', 'red');
                // element.find('.extra-thumbnail').css('background-image', 'url(http://fbs-mobile.app/' + scope.thumbnails[scope.initialThumbnailIndex] + ')');
            }
        }
    };
});
